"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createStyles_1 = require("@material-ui/styles/createStyles");
exports.default = (function () {
    return createStyles_1.default({
        footer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
        },
        footerContent: {
            width: '100%',
            maxWidth: 1200,
            boxSizing: 'content-box',
            justifyContent: 'space-around',
        },
        footerColumn: {
            maxWidth: 300,
        },
        footerHeader: {
            marginBottom: 10,
        }
    });
});
